class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    if (this.classList.contains('header__search')) {
      document.body.classList.add('open-search-modal');
      
      // Apply iOS-specific scroll lock (this will store scroll position)
      this.applyIOSScrollLock();
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (this.classList.contains('header__search')) {
      document.body.classList.remove('open-search-modal');
      
      // Remove iOS-specific scroll lock
      this.removeIOSScrollLock();
    }
  }

  // Detect iOS Safari
  isIOSSafari() {
    const ua = window.navigator.userAgent;
    const iOS = /iPad|iPhone|iPod/.test(ua);
    const webkit = /WebKit/.test(ua);
    const standalone = window.navigator.standalone;
    return iOS && webkit && !standalone;
  }

  // Apply iOS-specific scroll lock
  applyIOSScrollLock() {
    if (this.isIOSSafari()) {
      // Store the current scroll position more precisely
      this.scrollY = window.pageYOffset || document.documentElement.scrollTop;
      this.scrollX = window.pageXOffset || document.documentElement.scrollLeft;
      
      // Use a less intrusive approach - just prevent touch events
      this.addTouchPrevention();
    }
  }

  // Add touch event prevention for iOS
  addTouchPrevention() {
    this.touchPreventHandler = (e) => {
      // Allow touch events within the search modal
      if (this.contains(e.target)) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    // Add touch event listeners
    document.addEventListener('touchstart', this.touchPreventHandler, { passive: false });
    document.addEventListener('touchmove', this.touchPreventHandler, { passive: false });
    document.addEventListener('touchend', this.touchPreventHandler, { passive: false });
  }

  // Remove iOS-specific scroll lock
  removeIOSScrollLock() {
    if (this.isIOSSafari()) {
      // Remove touch event prevention
      this.removeTouchPrevention();
    }
  }

  // Remove touch event prevention
  removeTouchPrevention() {
    if (this.touchPreventHandler) {
      document.removeEventListener('touchstart', this.touchPreventHandler);
      document.removeEventListener('touchmove', this.touchPreventHandler);
      document.removeEventListener('touchend', this.touchPreventHandler);
    }
  }
}

customElements.define('details-modal', DetailsModal);
